export { default } from '@mui/base/ClickAwayListener';
export * from '@mui/base/ClickAwayListener';